import { render, staticRenderFns } from "./multi-drug-rapid-test-cup_h5.vue?vue&type=template&id=36e0efce&scoped=true&"
import script from "./multi-drug-rapid-test-cup_h5.vue?vue&type=script&lang=js&"
export * from "./multi-drug-rapid-test-cup_h5.vue?vue&type=script&lang=js&"
import style0 from "./multi-drug-rapid-test-cup_h5.vue?vue&type=style&index=0&id=36e0efce&scoped=true&lang=less&"
import style1 from "./multi-drug-rapid-test-cup_h5.vue?vue&type=style&index=1&id=36e0efce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0efce",
  null
  
)

export default component.exports